import { render, staticRenderFns } from "./referenciaBancaria.vue?vue&type=template&id=cdae7de4&scoped=true&"
import script from "./referenciaBancaria.vue?vue&type=script&lang=js&"
export * from "./referenciaBancaria.vue?vue&type=script&lang=js&"
import style0 from "./referenciaBancaria.vue?vue&type=style&index=0&id=cdae7de4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdae7de4",
  null
  
)

export default component.exports